import { Component, OnInit, ViewChild } from '@angular/core';
import { CompanyService } from '@app/_services';
import { AllAssessments, UserAssessmentStatus, ProctorResults } from '@app/_models';
declare var $: any;
declare const manageLoader: any;
import { ToastrService } from 'ngx-toastr';
import { FormControl } from '@angular/forms';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-all-profiles-assessment',
  templateUrl: './all-profiles-assessment.component.html',
  styleUrls: ['./all-profiles-assessment.component.less']
})
export class AllProfilesAssessmentComponent implements OnInit {
  allAssessmentData: AllAssessments[] = [];
  userAssessmentStatus;
  isLoading = false;
  minDate = new FormControl(new Date(new Date().setDate(new Date().getDate() - 7)));
  maxDate = new FormControl(new Date());
  userAssessmentProctorResults: ProctorResults;
  EXCEL_TYPE = 'application/vnd.openxmlformatsofficedocument.spreadsheetml.sheet;charset=UTF-8';
  EXCEL_EXTENSION = '.xlsx';
  todaysDate = new Date().toLocaleDateString();
  quickFilter = '';

  constructor(
    private companyService: CompanyService,
  ) { this.userAssessmentStatus = UserAssessmentStatus; }

  ngOnInit(): void {

  }

  getProfilesSummary() {
    this.allAssessmentData = [];
    manageLoader('load');
    this.isLoading = true;
    let startDate: Date = new Date(this.minDate.value);
    let endDate: Date = new Date(this.maxDate.value);    
    this.companyService.getAllProfilesSummary(this.formatDate(startDate), this.formatDate(endDate), this.quickFilter).subscribe((response: any) => {
      this.allAssessmentData.push(...response.data);
      this.allAssessmentData.sort((a, b) => (a.UserName < b.UserName ? -1 : 1));

      manageLoader();
      this.isLoading = false;
    })
  }

  getFormattedDate(date: Date) {
    return `${new Date(date).getMonth() + 1}-${new Date(date).getDate()}-${new Date(date).getFullYear()}`;
  }
  formatDate(date) {
    var year = date.getFullYear().toString();
    var month = (date.getMonth() + 101).toString().substring(1);
    var day = (date.getDate() + 100).toString().substring(1);
    return month + "-" + day + "-" + year;
  }

  replaceStatusByName(UserAssessmentStatusId: number): string {
    let returnStstus = '';
    if (UserAssessmentStatusId?.toString() === this.userAssessmentStatus?.Start) {
      returnStstus = 'Start';
    }
    else if (UserAssessmentStatusId?.toString() === this.userAssessmentStatus?.Pause) {
      returnStstus = 'Pause';
    }
    else if (UserAssessmentStatusId?.toString() === this.userAssessmentStatus?.Restart) {
      returnStstus = 'Restart';
    }
    else if (UserAssessmentStatusId?.toString() === this.userAssessmentStatus?.Complete) {
      returnStstus = 'Complete';
    }
    else if (UserAssessmentStatusId?.toString() === this.userAssessmentStatus?.Abort) {
      returnStstus = 'Abort';
    }
    else if (UserAssessmentStatusId?.toString() === this.userAssessmentStatus?.TimeOut) {
      returnStstus = 'TimeOut';
    }
    else if (UserAssessmentStatusId?.toString() === this.userAssessmentStatus?.Started) {
      returnStstus = 'Started';
    }
    else {
      returnStstus = 'NA';
    }
    return returnStstus;
  }

  downloadAsPDF(userAssessmentId: string) {
    this.isLoading = true;
    this.companyService.getProctorReportData(userAssessmentId).subscribe((res: any) => {
      this.isLoading = false;
      var contentType = "application/pdf";
      var blob = new Blob([(<any>res)], { type: contentType });
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = userAssessmentId;
      link.click();
    });
  }
  getProctorResults(userAssessmentId: string): void {
    this.isLoading = true;
    this.companyService.getProctorResultsByAssessmentId(userAssessmentId).pipe().subscribe((res: any) => {
      this.isLoading = false;
      this.userAssessmentProctorResults = res.data;
      if (this.userAssessmentProctorResults) {
        window.open(this.userAssessmentProctorResults.link, '_blank');
      }
    });
  }

  exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ['data'],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: this.EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName + '_export_' + this.todaysDate + this.EXCEL_EXTENSION
    );
  }

}